import axios from "axios";
import React, { useState } from "react";
import { Modal, Button, Form, Alert, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../config";
import { useAuth } from "../../context/AuthContext";
import "./glass.css";

const LoginModal = ({ show, handleClose }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [isLoading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const response = await axios.post(
        `${BASE_URL}/lisa_users/login/`,
        {
          username: username.trim(),
          password: password,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      const user = response.data;

      // Optional: make role check case-insensitive
      if (user && user.role?.toLowerCase() === "administrator") {

        login({
          id: user.id,
          username: user.username,
          role: user.role,
          province: user.province,
          city_municipality: user.city_municipality,
        });

        navigate("/dashboard");
        handleClose();
      } else {
        setError("Access denied. Administrator role required.");
      }
    } catch (err) {
      console.error("Login error:", err);
      if (err.response && err.response.status === 401) {
        setError("Invalid username or password");
      } else if (err.response) {
        setError(
          `Server error (${err.response.status}): ${
            err.response.data?.message || "Please try again."
          }`
        );
      } else if (err.request) {
        setError(
          "Cannot reach server. Check your internet connection or CORS settings."
        );
      } else {
        setError("An error occurred. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  // ✅ NEW FUNCTION FOR SIGNUP
  const handleCreateAccount = () => {
    handleClose();        // close login modal
    navigate("/signup");  // change to "/register" if needed
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="md"
      dialogClassName="modal-glass"
      backdropClassName="modal-backdrop-glass"
    >
      <Modal.Header closeButton>
        <Modal.Title
          className="text-center w-100"
          style={{
            fontWeight: "bold",
            fontSize: "2rem",
            color: "rgb(52, 142, 56)",
            fontFamily: "'Poppins', sans-serif",
            textShadow: "0 6px 18px rgba(208, 227, 213, 0.12)",
          }}
        >
          Login
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {error && (
          <Alert
            variant="danger"
            style={{
              fontSize: "0.85rem",
              padding: "8px 12px",
              marginBottom: "12px",
              borderRadius: "14px",
              background: "rgba(220,53,69,0.18)",
              border: "1px solid rgba(220,53,69,0.35)",
              color: "rgba(255,255,255,0.92)",
            }}
          >
            {error}
          </Alert>
        )}

        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="formUsername">
            <Form.Label style={{ color: "#fff" }}>Username</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              style={{
                fontFamily: "'Poppins', sans-serif",
                fontSize: "0.9rem",
                color: "white",
              }}
            />
          </Form.Group>

          <Form.Group controlId="formPassword" className="mt-3">
            <Form.Label style={{ color: "#fff" }}>Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                fontFamily: "'Poppins', sans-serif",
                fontSize: "0.9rem",
                color: "white",
              }}
            />
          </Form.Group>

          <Button
            type="submit"
            className="mt-4 w-100 btn-glass"
            disabled={isLoading}
            style={{ borderRadius: "999px", padding: "12px" }}
          >
            {isLoading ? (
              <Spinner animation="border" size="sm" />
            ) : (
              "Login"
            )}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default LoginModal;